import { render, staticRenderFns } from "./LicitacaoFornecedorAcoesCancelarEnvio.vue?vue&type=template&id=bf80b62a"
import script from "./LicitacaoFornecedorAcoesCancelarEnvio.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorAcoesCancelarEnvio.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorAcoesCancelarEnvio.vue?vue&type=style&index=0&id=bf80b62a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports